import { RACE_COLORS, FONT_FAMILY } from "../constants.js";

const cardStyle = {
  background: "#f8f9fa",
  border: "1px solid #e0e0e0",
  borderRadius: 10,
  padding: "18px 20px",
  flex: 1,
  minWidth: 0,
};

const labelStyle = {
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: "0.08em",
  color: "#555",
  textTransform: "uppercase",
  fontFamily: FONT_FAMILY,
  marginBottom: 6,
};

const valueStyle = (color) => ({
  fontSize: 36,
  fontWeight: 800,
  color,
  fontFamily: FONT_FAMILY,
  lineHeight: 1.1,
});

const subStyle = {
  fontSize: 12,
  color: "#777",
  fontFamily: FONT_FAMILY,
  marginTop: 4,
};

export default function StopRateCards({ black_rate, white_rate }) {
  return (
    <div style={{ display: "flex", gap: 16, marginTop: 8, marginBottom: 8 }}>
      <div style={cardStyle}>
        <div style={labelStyle}>Black Rate Per 1K / Yr</div>
        <div style={valueStyle(RACE_COLORS.BLACK)}>
          {black_rate != null ? black_rate.toFixed(2) : "—"}
        </div>
        <div style={subStyle}>stops per 1,000 Black residents per year</div>
      </div>
      <div style={cardStyle}>
        <div style={labelStyle}>White Rate Per 1K / Yr</div>
        <div style={valueStyle(RACE_COLORS.WHITE)}>
          {white_rate != null ? white_rate.toFixed(2) : "—"}
        </div>
        <div style={subStyle}>stops per 1,000 White residents per year</div>
      </div>
    </div>
  );
}
